import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokens = {
  opportunityQuotes: null,
};

class QuotesService {
  getQuotes({ opportunityId }) {
    if (cancelTokens.opportunityQuotes) cancelTokens.opportunityQuotes.cancel('Multiple requests.');
    cancelTokens.opportunityQuotes = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/quotes`, {
      cancelToken: cancelTokens.opportunityQuotes.token,
    }).then((response) => response.data);
  }

  createQuote({ opportunityId, payload }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/quotes`, payload).then(
      (response) => response.data,
    );
  }

  deleteQuote({ opportunityId, quoteId }) {
    return ApiService.delete(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/quotes/${quoteId}`).then(
      (response) => response.data,
    );
  }

  updateQuote({ opportunityId, quoteId, quote }) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/quotes/${quoteId}`,
      quote,
    ).then((response) => response.data);
  }
}

export const quotesService = new QuotesService();
